<script lang="ts" setup>
import ShareAndroidIcon from '@lahaus-roomie/roomie/src/assets/icons/share-android.svg'

import type { Props } from './types'

import PdFinancialInfo from '@/components/pd/FinancialInfo/index.vue'

import { getProductTypeLabel } from '@/utils/project'
import { useAppChatStore } from '@/stores/appChatStore'

const props = defineProps<Props>()
const appChatStore = useAppChatStore()
const handleReferAndEarnClick = () => {
  const endpointConfig = {
    screen: 'PDP',
    entryNameAlias: 'PDP_REFER_AND_EARN',
    startFlow: true,
    shouldCallBotForGreeting: true
  }
  appChatStore.openChatWindow(endpointConfig)
}

const { t } = useI18n()

const productType = getProductTypeLabel(props.listing.raw_listing.attributes.product_type, true, true, t)
</script>

<script lang="ts">
export default {
  name: 'PdFeaturesSummary'
}
</script>

<template>
  <div class="pd-features-summary my-24 px-24 xl:px-48">
    <PdFinancialInfo
      class="w-full flex justify-between lg:hidden"
      :listing />

    <p class="text-12 text-carbon-600 whitespace-nowrap mb-24 mt-8 lg:hidden">
      {{ t('disclaimer', {
        value: listing.area_label,
        type: productType.toLowerCase(),
        n: productType.toLowerCase() == 'casa' ? 2 : 1
      }) }}
    </p>

    <div
      class="tag-holder flex flex-col gap-8 px-16 py-16 bg-success-50 rounded-[16px] justify-between lg:flex-row lg:items-center">
      <p
        v-sanitize="t('referralText')"
        class="text-18 lg:text-22" />

      <button
        id="pdp-refer-and-earn-button"
        type="button"
        data-lh-id="pdp-refer-and-earn-button"
        class="text-primary-600 text-18 underline flex items-center gap-8"
        @click="handleReferAndEarnClick">
        <p class="pointer-events-none">
          {{ t('ctaText') }}
        </p>

        <ShareAndroidIcon class="w-20 h-20 fill-primary-600 pointer-events-none" />
      </button>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json" />
